import { CircularProgress, styled } from "@mui/material";
import { useEffect, useState, MutableRefObject } from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import ReactPlayer from "react-player/lazy";
import colors from "../../theme/themeConstants";

interface IProps {
  fileUrl: string;
  file: File;
  setFileUrl: (url: string) => void;
  fileType: string | null;
  playerRef: MutableRefObject<ReactPlayer | null>;
  duration: number[];
  fromUrl: string;
  isEnabledSound: boolean;
}

const CropFile = (props: IProps) => {
  const { file, fileType, playerRef, duration, fromUrl, isEnabledSound } = props;

  const [localURL, setLocalURL] = useState("");

  const handleDuration = (currentTime: number) => {
    if (Number(currentTime.toFixed(2)) >= duration[1]) {
      playerRef?.current?.seekTo(duration[0], "seconds");
    }
  };

  useEffect(() => {
    if (fromUrl) {
      setLocalURL(fromUrl);

      return;
    }
    setLocalURL(URL.createObjectURL(file));
    return () => {
      if (!fromUrl) {
        URL.revokeObjectURL(localURL);
      }
    };
    // eslint-disable-next-line
  }, [file])

  useEffect(() => {
    if (playerRef && playerRef.current) {
      playerRef.current.seekTo(duration[0], "seconds");
    }
    // eslint-disable-next-line
  }, [playerRef])

  return (
    <Container>
      {/* eslint-disable-next-line */}
      {fileType === "image" && <img src={localURL}/>}
      {fileType === "video" && (
        <LazyLoadComponent>
          <ReactPlayer
            url={`${localURL}`}
            ref={playerRef}
            muted={!isEnabledSound}
            progressInterval={10}
            playing
            previewTabIndex={10}
            fallback={(
              <PreviewContainer>
                <CircularProgress sx={{ position: "absolute", color: colors.white }}/>
              </PreviewContainer>
            )}
            loop
            playsinline
            onProgress={(d) => handleDuration(d.playedSeconds)}
            style={{
              width: "100%",
              maxHeight: "307px"
            }}
          />
        </LazyLoadComponent>
      )}
    </Container>
  );
};

export default CropFile;

const Container = styled("div")({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  width: "100%",
  "& div": {
    height: "fit-content !important",
    maxHeight: "307px"
  },
  "& img": {
    objectFit: "cover",
    maxHeight: "307px"
  },
  "& video": {
    maxHeight: "307px",
  }
});

const PreviewContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  padding: "1rem 0",
  minHeight: "200px"
});
